import 'firebase/compat/auth';
import firebase from 'firebase/compat/app';
import { FIREBASE_CONFIG } from './config';

firebase.initializeApp(FIREBASE_CONFIG);

const auth = firebase.auth();

// Use session persistence — Firebase auth clears on browser close.
// HttpOnly refresh token cookie (7-day expiry) handles "remember me" via silent refresh.
auth.setPersistence(firebase.auth.Auth.Persistence.SESSION).catch(() => {
  // Silently handle - fallback to default persistence
});

export { auth, firebase };
